import { useState } from 'react';
import { generateId } from '@lsoft/shared/functions/generateId';

export const useUniqueId = (prefix) => {
	const [id] = useState(generateId(prefix, 32));
	return id;
};
